// extracted by mini-css-extract-plugin
export var centerAlign = "CartOnboarding_centerAlign__MStii";